import {DG_axios} from "../../custom/axios";

const urlWorkspace = `/dogoo/resource-action-rest/v2.0/resource/workspaces/tnp/accounts`;

export async function getWorkspaceByWorkspaceKeyAndAccountId (accountId) {
    const response = await DG_axios.get( `${urlWorkspace}/${accountId}`)
    return response?.data || []
}
